import {Lang} from 'yougile-lang'
import {UIUtil} from 'yougile-util'
import {Hub} from 'yougile-model'
import {FileChooser} from '@common/file-chooser'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {FileUploadProgress} from '@components/file-upload-progress'
import {MessageBox} from '@components/message-box'

export const uploadCover = async (
  hub: Hub,
  type?: 'board' | 'right-panel'
): Promise<void> => {
  const file = await FileChooser.chooseFile({}, false, undefined, 'image/*')
  if (!UIUtil.isSupportedImage(file)) {
    MessageBox.warn(Lang.msg.imageTypeUnsupported)
    return
  }

  if (type === 'board') {
    void Tracking.send(TrackingEvent.taskCoverUploadCoverViaBoardTaskMenu)
  }
  if (type === 'right-panel') {
    void Tracking.send(TrackingEvent.taskCoverUploadCoverViaRightPanelTaskMenu)
  }

  const url = await FileUploadProgress.saveFile(file)
  hub.data.image = url
  hub.commit()
}
